module.exports = __webpack_public_path__ + "img/system-network-topology.a4fcf76a.png";